import { useState } from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import Swiper from "react-id-swiper";
import { faq } from "../../lib/workshopMarketingFaq";
import { FaPlus } from "react-icons/fa";
import FAQItem from "../Homepage/FAQItem";

const WorkshopMarketingFAQ = ({}) => {
  const [show, setShow] = useState(true);
  return (
    <Container>
      <h2 className="my-4 text-center faq-color-all">Frequently Asked Questions (FAQs)</h2>
      <Row>
        <Col
          xs={12}
          className="d-flex justify-content-center align-items-center"
        >
          <div className="faq-model">
            {faq.map((item, index) => (
              <>
                <FAQItem data={item} show={show} setShow={setShow} />
              </>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default WorkshopMarketingFAQ;
